module.exports = __webpack_public_path__ + "static/scale-model-of-piedmont-wildlife-center-in-durham-north-carolina-7eb515746d9abf38ff5ec70149f51969.png";